export default "__VITE_ASSET__A5Z_6gUc__"